"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSanitizer = void 0;
var CodeSanitizer_1 = require("./CodeSanitizer");
var DigitsSanitizer_1 = require("./DigitsSanitizer");
var IntegerSanitizer_1 = require("./IntegerSanitizer");
var MoneySanitizer_1 = require("./MoneySanitizer");
var FieldSanitizer = /** @class */ (function () {
    function FieldSanitizer(type) {
        this.sanitizer = this.findSanitizer(type);
    }
    FieldSanitizer.prototype.format = function (value) {
        if (this.sanitizer) {
            return this.sanitizer.format(value);
        }
        return value;
    };
    FieldSanitizer.prototype.sanitize = function (value) {
        if (this.sanitizer) {
            return this.sanitizer.sanitize(value);
        }
        return value;
    };
    FieldSanitizer.prototype.blockUnallowedCharacters = function (value) {
        if (this.sanitizer) {
            return this.sanitizer.blockUnallowedCharacters(value);
        }
        return value;
    };
    FieldSanitizer.prototype.findSanitizer = function (type) {
        switch (type) {
            case 'integer':
                return new IntegerSanitizer_1.IntegerSanitizer();
            case 'money':
                return new MoneySanitizer_1.MoneySanitizer();
            case 'digits':
                return new DigitsSanitizer_1.DigitsSanitizer();
            case 'code':
                return new CodeSanitizer_1.CodeSanitizer();
            default:
                return;
        }
    };
    return FieldSanitizer;
}());
exports.FieldSanitizer = FieldSanitizer;
//# sourceMappingURL=FieldSanitizer.js.map